import * as Sentry from "@sentry/react";

export function initSentry() {
  const dsn = import.meta.env.VITE_SENTRY_DSN;

  if (!dsn) {
    console.warn("[Sentry] VITE_SENTRY_DSN not set — skipping Sentry init");
    return;
  }

  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    release: import.meta.env.VITE_SENTRY_RELEASE || undefined,

    // Performance — sample 10% of transactions in prod, 100% in dev
    tracesSampleRate: import.meta.env.MODE === "production" ? 0.1 : 1.0,

    // Session Replay — capture 1% of sessions, 100% of sessions with errors
    replaysSessionSampleRate: 0.01,
    replaysOnErrorSampleRate: 1.0,

    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],

    // Filter noisy or irrelevant errors
    beforeSend(event) {
      // Ignore ResizeObserver errors (benign browser quirk)
      if (event.exception?.values?.some((e) => e.value?.includes("ResizeObserver"))) {
        return null;
      }
      return event;
    },
  });
}

/**
 * Set Sentry user context when the user logs in, clear on logout.
 */
export function setSentryUser(user: { id: string; email?: string } | null) {
  if (user) {
    Sentry.setUser({ id: user.id, email: user.email });
  } else {
    Sentry.setUser(null);
  }
}
